import React, { useEffect } from 'react'
import useClipboard from 'react-use-clipboard'
import { useToast } from '@entur/alert'
import { Tooltip } from '@entur/tooltip'
import { CopyIcon } from '@entur/icons'
import { space } from '@entur/tokens'

type CopyButtonProps = {
  value: string
  description: string
  size?: string | number
}

const CopyButton: React.FC<CopyButtonProps> = ({ value, description, size }) => {
  const { addToast } = useToast()
  const [isCopied, setCopied] = useClipboard(value, {
    // `isCopied` will go back to `false` after 1000ms.
    successDuration: 1000,
  })

  useEffect(() => {
    if (isCopied) {
      addToast({
        title: `${description} kopiert!`,
        content: 'Bruk "Ctrl + V" for å lime inn verdien der du vil.',
      })
    }
  }, [isCopied, description, addToast])

  return (
    <Tooltip content={`Kopier ${description.toLowerCase()}`} placement="top">
      <span>
        <CopyIcon
          style={{ cursor: 'pointer', marginLeft: space.extraSmall2, ...(size ? { fontSize: size } : {}) }}
          onClick={setCopied}
        />
      </span>
    </Tooltip>
  )
}

export default CopyButton
